import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import Pagination from '../../component/Admin/Pagination';
import { FaEdit, FaPlusCircle, FaTrashAlt, FaSearch, FaBook, FaCog, FaTimes } from 'react-icons/fa';
import Loading from '../../component/Loading';
import Modal from 'react-modal';
import Swal from 'sweetalert2';
import ReactQuill, { Quill } from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { canAccess } from '../../helper/permissions';
import {
    headerImageUrl,
    coverImageUrl,
    signatureImageUrl,
    withLegacyImageFallback,
} from '../../helper/mediaUrl';
import ImageUploadField from '../../component/ImageUploadField';

// Add alignment options to Quill
const Align = Quill.import('formats/align');
Align.className = 'ql-align'; // Set the class name for alignment
Quill.register(Align, true); // Register the alignment format

const Journal = ({ data }) => {
    const navigate = useNavigate();

    const header = {
        headers: { 'Authorization': `Bearer ${data.token}` }
    }
    const permissions = data?.user?.permissions || {};
    const canCreate = canAccess(permissions, 'journal', 'create');
    const canEdit = canAccess(permissions, 'journal', 'edit');
    const canDelete = canAccess(permissions, 'journal', 'delete');
    const canCreateLoa = canAccess(permissions, 'loa', 'create');
    const [listJournal, setListJournal] = useState([]);
    const [meta, setMeta] = useState({});
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const [loading, setLoading] = useState(false);
    const [search, setSearch] = useState('');
    // const [userEmail, setUserEmail] = useState([]);
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [modalData, setModalData] = useState(null);
    const [editorData, setEditorData] = useState(''); // State untuk menyimpan data React Quill
    const [headerFile, setHeaderFile] = useState(null);
    const [coverFile, setCoverFile] = useState(null);
    const [signatureFile, setSignatureFile] = useState(null);

    useEffect(() => {
        getListJournal();
        // eslint-disable-next-line
    }, [page, limit, search]);

    const getListJournal = () => {
        // setLoadingSmall(true)
        const searchParam = search ? `&search=${encodeURIComponent(search)}` : '';
        axios.get(`api/journal?page=${page}&limit=${limit}${searchParam}`, header)
            .then((response) => {
                setMeta(response.data.meta);
                setListJournal(response.data.items);
            })
            .catch((error) => {
                console.error('Error fetching data:', error);
            });
    };
    const selectPage = (value) => {
        setPage(value);
    };

    const nextPage = () => {
        if (page < meta.totalPages) {
            setPage(page + 1);
        }
    };

    const prevPage = () => {
        if (page > 1) {
            setPage(page - 1);
        }
    };

    const limitPage = (event) => {
        setLimit(Number(event.target.value));
        setPage(1);
    };





    const handleSubmit = (event) => {
        event.preventDefault();
        const formData = new FormData(event.target);
        formData.delete('header');
        formData.delete('cover');
        formData.delete('signature');

        if (headerFile) {
            formData.append('header', headerFile);
        }
        if (coverFile) {
            formData.append('cover', coverFile);
        }
        if (signatureFile) {
            formData.append('signature', signatureFile);
        }

        if (!modalData[0] && !headerFile) {
            Swal.fire('Gagal', 'Header journal wajib diupload.', 'error');
            return;
        }

        formData.append('message', editorData);


        // return false
        if (modalData[0]) {
            axios.patch(`api/journal/${modalData[0].journal_id}`, formData, header)
                .then(() => {
                    Swal.fire({
                        message: `Success `,
                        icon: "success",
                        text: "Journal Berhasil diupdate",
                        confirmButtonText: `Tutup`,
                        confirmButtonColor: "#4569ab",
                    }).then((e) => {
                        getListJournal(); // Refresh daftar
                        closeModal();
                    })
                })
                .catch((error) => {
                    console.error('Error updating data:', error);
                });
        } else {
            axios.post('api/journal', formData, header)
                .then(() => {
                    getListJournal();
                    closeModal();
                    Swal.fire({
                        message: `Success `,
                        icon: "success",
                        text: "Journal Berhasil ditambahkan",
                        confirmButtonText: `Tutup`,
                        confirmButtonColor: "#4569ab",
                    });
                })
                .catch((error) => {
                    console.error('Error adding data:', error);
                });
        }
    };


    const handleClickEdit = (id) => {
        const entry = listJournal.find((item) => item.journal_id === id);

        if (entry) {
            setEditorData(entry.message);
            setHeaderFile(null);
            setCoverFile(null);
            setSignatureFile(null);
            setModalData([entry]);
            setModalIsOpen(true);
        } else {
            setModalData(null);
            setModalIsOpen(false);
        }
    };

    const closeModal = () => {
        setEditorData("")
        setHeaderFile(null);
        setCoverFile(null);
        setSignatureFile(null);
        setModalData({
            journal_name: "",
            message: "",
            journal_manager: "",
            journal_path: "",
            header: "",
            cover: "",
            signature: "",
        }); // Reset modal data for new entry
        setModalIsOpen(false);
    }
    const openAddModal = () => {
        setHeaderFile(null);
        setCoverFile(null);
        setSignatureFile(null);
        setModalData({
            journal_name: "",
            message: "",
            journal_manager: "",
            journal_path: "",
            header: "",
            cover: "",
            signature: "",
        }); // Reset modal data for new entry
        setModalIsOpen(true); // Open modal
    };

    const modules = {
        toolbar: [
            [{ 'header': [1, 2, false] }], // Header options
            ['bold', 'italic', 'underline', 'strike'], // Text formatting options
            [{ 'list': 'ordered' }, { 'list': 'bullet' }], // List options
            [{ 'script': 'sub' }, { 'script': 'super' }], // Subscript and superscript
            [{ 'indent': '-1' }, { 'indent': '+1' }], // Indentation options
            [{ 'direction': 'rtl' }], // Text direction
            [{ 'color': [] }, { 'background': [] }], // Text and background color options
            [{ 'align': [] }], // Text alignment options
            ['link'], // Link, image, and video options
            ['clean'] // Clear formatting button
        ],
    };

    const handleDelete = (journalId) => {

        Swal.fire({
            title: 'Hapus Journal?',
            text: 'Tindakan ini tidak dapat dibatalkan.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#4569ab',
            cancelButtonColor: '#5C5E62',
            confirmButtonText: 'Ya, hapus',
            cancelButtonText: 'Batal'
        }).then((result) => {
            if (result.isConfirmed) {
                setLoading(true);
                axios.delete(`api/journal/${journalId}`, header)
                    .then(() => {
                        // Optimistic update: remove from list without refetch
                        setListJournal((prev) => prev.filter(j => j.journal_id !== journalId));
                        Swal.fire({
                            message: 'Success',
                            icon: 'success',
                            text: 'Journal berhasil dihapus',
                            confirmButtonText: 'Tutup',
                            confirmButtonColor: '#4569ab',
                        });
                    })
                    .catch((error) => {
                        console.error('Error deleting data:', error);
                        Swal.fire({
                            title: 'Gagal',
                            text: 'Terjadi kesalahan saat menghapus data.',
                            icon: 'error'
                        });
                    })
                    .finally(() => {
                        setLoading(false);
                    });
            }
        });
    };

    return (
        <>
            {loading ? <Loading /> : null}

            <div className="space-y-4">
                {/* Search */}
                <div className="card">
                    <div className="card-body toolbar-row !py-4">
                        <div className="toolbar-search relative">
                            <FaSearch className="pointer-events-none absolute left-3 top-1/2 h-3.5 w-3.5 -translate-y-1/2 text-muted" />
                            <input
                                type="text"
                                value={search}
                                onChange={(e) => {
                                    setSearch(e.target.value);
                                    setPage(1);
                                }}
                                className="input w-full !pl-9 !pr-9"
                                placeholder="Cari journal..."
                            />
                            {search ? (
                                <button
                                    type="button"
                                    onClick={() => {
                                        setSearch('');
                                        setPage(1);
                                    }}
                                    className="absolute right-2 top-1/2 flex h-6 w-6 -translate-y-1/2 items-center justify-center rounded-xs text-muted transition-colors duration-tesla hover:bg-surface-soft hover:text-ink dark:hover:bg-white/10 dark:hover:text-white"
                                    title="Hapus pencarian"
                                    aria-label="Hapus pencarian"
                                >
                                    <FaTimes className="h-3 w-3" />
                                </button>
                            ) : null}
                        </div>
                        <div className="tag shrink-0 tabular-nums">
                            <FaBook className="h-3 w-3" />
                            <span>{listJournal.length}</span>
                            <span className="hidden sm:inline">
                                {listJournal.length === 1 ? 'Journal' : 'Journals'}
                            </span>
                        </div>
                        {canCreate ? (
                            <button
                                onClick={openAddModal}
                                className="btn-primary toolbar-action shrink-0"
                                type="button"
                            >
                                <FaPlusCircle />
                                <span>Tambah Journal</span>
                            </button>
                        ) : null}
                    </div>
                </div>

                {/* Journal Grid */}
                {listJournal.length > 0 ? (
                    <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
                        {listJournal.map((item, index) => (
                            <article
                                key={index}
                                className="card-interactive flex flex-col overflow-hidden"
                            >
                                <div className="flex h-14 items-center justify-center bg-white dark:bg-white/5">
                                    <img
                                        src={headerImageUrl(item?.header)}
                                        className="h-full w-full object-cover"
                                        alt={item.journal_name}
                                        onError={(e) => {
                                            if (e.target.dataset.legacyFallback !== '1' && item?.header) {
                                                withLegacyImageFallback(e, item.header);
                                                return;
                                            }
                                            e.target.src =
                                                'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="332" height="111"%3E%3Crect fill="%23F4F4F4" width="332" height="111"/%3E%3Ctext fill="%235C5E62" font-family="sans-serif" font-size="14" dy="10.5" font-weight="500" x="50%25" y="50%25" text-anchor="middle"%3ENo Image%3C/text%3E%3C/svg%3E';
                                        }}
                                    />
                                </div>

                                <div className="flex flex-1 flex-col p-4">
                                    <div className="mb-2 flex items-center gap-2">
                                        <div className="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-xs bg-surface-soft text-muted dark:bg-white/5">
                                            <FaBook className="h-3.5 w-3.5" />
                                        </div>
                                        <div className="line-clamp-2 flex-1 text-left text-xs font-medium leading-snug text-ink dark:text-white">
                                            {item.journal_name}
                                        </div>
                                    </div>

                                    <div className="mt-auto flex gap-2 pt-3">
                                        {canCreateLoa ? (
                                            <button
                                                type="button"
                                                onClick={() => navigate(`/admin/loa/create?journal=${item.journal_id}`)}
                                                className="btn-primary flex flex-1 items-center justify-center !min-h-8 !px-2 !py-1.5 !text-xs"
                                                title="Tambah LOA"
                                            >
                                                <FaPlusCircle className="mr-1 h-3 w-3" />
                                                <span>LOA</span>
                                            </button>
                                        ) : null}
                                        <button
                                            type="button"
                                            onClick={() => navigate(`/admin/journal/${item.journal_id}/issues`)}
                                            className="btn-secondary flex h-8 w-8 shrink-0 items-center justify-center !min-h-8 !p-0 !text-xs"
                                            title="Manage Issues"
                                            aria-label="Manage Issues"
                                        >
                                            <FaCog className=' text-[#f67a07]' />
                                        </button>
                                        {canEdit ? (
                                            <button
                                                type="button"
                                                onClick={() => handleClickEdit(item.journal_id)}
                                                className="btn-secondary flex h-8 w-8 shrink-0 items-center justify-center !min-h-8 !p-0 !text-xs"
                                                title="Edit Journal"
                                                aria-label="Edit Journal"
                                            >
                                                <FaEdit className=' text-primary' />
                                            </button>
                                        ) : null}
                                        {canDelete ? (
                                            <button
                                                type="button"
                                                onClick={() => handleDelete(item.journal_id)}
                                                className="btn-pearl flex h-8 w-8 shrink-0 items-center justify-center !min-h-8 !p-0 !text-xs text-muted hover:text-ink dark:hover:text-white"
                                                title="Hapus Journal"
                                                aria-label="Hapus Journal"
                                            >
                                                <FaTrashAlt className=' text-red-600' />
                                            </button>
                                        ) : null}
                                    </div>
                                </div>
                            </article>
                        ))}
                    </div>
                ) : (
                    <div className="card card-body py-16 text-center">
                        <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-md bg-surface-soft text-muted dark:bg-white/5">
                            <FaBook className="h-7 w-7" />
                        </div>
                        <h3 className="mb-2 text-lg font-medium text-ink dark:text-white">
                            {search ? 'Journal tidak ditemukan' : 'Belum ada Journal'}
                        </h3>
                        <p className="mx-auto mb-6 max-w-md text-sm text-muted">
                            {search
                                ? `Tidak ada journal yang sesuai dengan "${search}"`
                                : 'Mulai dengan menambahkan journal baru untuk mengelola publikasi Anda'}
                        </p>
                        {!search && canCreate && (
                            <button
                                type="button"
                                onClick={openAddModal}
                                className="btn-primary"
                            >
                                <FaPlusCircle />
                                <span>Tambah Journal Pertama</span>
                            </button>
                        )}
                    </div>
                )}

                {listJournal.length > 0 && (
                    <Pagination
                        currentPage={page}
                        totalPages={meta.totalPages}
                        limit={limit}
                        limitPage={limitPage}
                        selectPage={selectPage}
                        nextPage={nextPage}
                        prevPage={prevPage}
                    />
                )}
            </div>
            <Modal
                isOpen={modalIsOpen}
                onRequestClose={closeModal}
                contentLabel="Detail Modal"
                ariaHideApp={false}
                className="fixed inset-0 z-50 flex items-center justify-center p-4"
                overlayClassName="fixed inset-0 z-50 bg-black/60 backdrop-blur-sm"
                shouldCloseOnOverlayClick={true}
            >
                {modalData && (
                    <form onSubmit={handleSubmit} className="modal flex max-h-[90vh] w-full max-w-4xl flex-col overflow-hidden">
                        <div className="flex shrink-0 items-center justify-between border-b border-hairline px-6 py-4 dark:border-white/10">
                            <h2 className="text-[17px] font-medium text-ink dark:text-white">Journal</h2>
                            <button
                                type="button"
                                onClick={closeModal}
                                className="btn-pearl !min-h-8 !px-3 !py-1"
                                aria-label="Tutup"
                            >
                                ×
                            </button>
                        </div>
                        <div className="min-h-0 flex-1 overflow-y-auto px-6 py-5">
                            <div className="mb-4">
                                <label className="mb-1.5 block text-left text-sm font-medium text-ink dark:text-white">
                                    Journal Name<sup className="text-error">*</sup>
                                </label>
                                <input
                                    id="journal_name"
                                    type="text"
                                    name="journal_name"
                                    placeholder="Journal Name"
                                    className="input w-full"
                                    required
                                    defaultValue={modalData ? modalData[0]?.journal_name : ''}
                                />
                            </div>
                            <div className="mb-4">
                                <label htmlFor="message" className="mb-1.5 block text-left text-sm font-medium text-ink dark:text-white">
                                    Message
                                </label>
                                <div className="overflow-hidden rounded-xs border border-border-strong dark:border-white/10 dark:bg-tile-2">
                                    <ReactQuill
                                        theme="snow"
                                        value={editorData}
                                        onChange={setEditorData}
                                        modules={modules}
                                        style={{ height: '200px', marginBottom: '50px' }}
                                    />
                                </div>
                            </div>

                            <div className="mb-4">
                                <label htmlFor="journal_manager" className="mb-1.5 block text-left text-sm font-medium text-ink dark:text-white">
                                    Journal Manager<sup className="text-error">*</sup>
                                </label>
                                <input
                                    id="journal_manager"
                                    type="text"
                                    name="journal_manager"
                                    placeholder="Journal Manager"
                                    className="input w-full"
                                    required
                                    defaultValue={modalData ? modalData[0]?.journal_manager : ''}
                                />
                            </div>
                            <div className="mb-4">
                                <label htmlFor="journal_path" className="mb-1.5 block text-left text-sm font-medium text-ink dark:text-white">
                                    Journal Path<sup className="text-error">*</sup>
                                </label>
                                <input
                                    id="journal_path"
                                    type="text"
                                    name="journal_path"
                                    placeholder="Journal Path"
                                    className="input w-full"
                                    required
                                    defaultValue={modalData ? modalData[0]?.journal_path : ''}
                                />
                            </div>
                            <div className="mb-4">
                                <label htmlFor="journal_publish" className="mb-1.5 block text-left text-sm font-medium text-ink dark:text-white">
                                    Journal Publish<sup className="text-error">*</sup>
                                </label>
                                <input
                                    id="journal_publish"
                                    type="url"
                                    name="journal_publish"
                                    placeholder="https://journal.com/index.php/YOURPATH"
                                    className="input w-full"
                                    required
                                    defaultValue={modalData ? modalData[0]?.journal_publish : ''}
                                />
                            </div>
                            <div className="mb-4 space-y-3 rounded-md border border-hairline p-4 dark:border-white/10">
                                <p className="text-sm font-medium text-ink dark:text-white">
                                    Gambar jurnal
                                </p>
                                <ImageUploadField
                                    compact
                                    label="Cover (Home)"
                                    currentUrl={
                                        modalData[0]?.cover
                                            ? coverImageUrl(modalData[0].cover)
                                            : null
                                    }
                                    file={coverFile}
                                    onFileChange={setCoverFile}
                                    hint="Slider beranda · PNG/JPG · maks. 1MB"
                                    emptyTitle="Upload cover,"
                                    previewAlt="Cover journal"
                                    activeLabel="Cover aktif"
                                />
                                <ImageUploadField
                                    compact
                                    label="Header"
                                    required={!modalData[0]}
                                    currentUrl={
                                        modalData[0]?.header
                                            ? headerImageUrl(modalData[0].header)
                                            : null
                                    }
                                    file={headerFile}
                                    onFileChange={setHeaderFile}
                                    hint="Banner LOA · PNG/JPG · maks. 1MB"
                                    emptyTitle="Upload header,"
                                    previewAlt="Header journal"
                                    activeLabel="Header aktif"
                                />
                                <ImageUploadField
                                    compact
                                    label="Tanda tangan (PDF LOA)"
                                    currentUrl={
                                        modalData[0]?.signature
                                            ? signatureImageUrl(modalData[0].signature)
                                            : null
                                    }
                                    file={signatureFile}
                                    onFileChange={setSignatureFile}
                                    hint="PNG/JPG transparan · maks. 1MB"
                                    emptyTitle="Upload tanda tangan,"
                                    previewAlt="Tanda tangan"
                                    activeLabel="Tanda tangan aktif"
                                />
                            </div>
                        </div>
                        <div className="flex shrink-0 gap-3 border-t border-hairline px-6 py-4 dark:border-white/10">
                            <button type="button" onClick={closeModal} className="btn-secondary flex-1">
                                Batal
                            </button>
                            <button type="submit" className="btn-primary flex-1">
                                Simpan
                            </button>
                        </div>
                    </form>
                )}
            </Modal>
        </>
    );
};

export default Journal;